import { render, staticRenderFns } from "./CompetenceCoreSkills.vue?vue&type=template&id=22f9b137&scoped=true"
import script from "./CompetenceCoreSkills.vue?vue&type=script&lang=js"
export * from "./CompetenceCoreSkills.vue?vue&type=script&lang=js"
import style0 from "./CompetenceCoreSkills.vue?vue&type=style&index=0&id=22f9b137&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f9b137",
  null
  
)

export default component.exports